export const changeableTerm = 1;